<template>
  <div>
    <text-editor
      v-if="item.cardType?.domainModelRole !== DomainModelRole.TAG"
      ref="editor"
      :id="'editor' + item.id"
      :class="['pa-1', !borderColor ? 'border-none' : '']"
      :tabindex="index"
      :text="item.description"
      :disabled="$store.state.isWorkflowDisabled"
      @text-update="updateDescription"
      @move-focus="moveFocus"
      :borderColor="borderColor"
    />
    <tag-input
      v-if="item.cardType?.domainModelRole === DomainModelRole.TAG"
      class="pa-1"
      :cardId="item.id"
    />
  </div>
</template>

<script>
import workflowApi from '@/api/workflowApi'
import TextEditor from '@/components/TextEditor.vue'
import TagInput from '@/components/TagInput.vue'
import { EventBus } from '@/event-bus/event-bus.js'
import cardTypesApi from '@/api/cardTypesApi'
import { DomainModelRole } from '@/constants/cardTypes'

export default {
  props: {
    item: Object,
    index: Number,
    focusCard: String,
    scrollIntoViewArg: Boolean
  },

  components: {
    TextEditor,
    TagInput
  },

  data () {
    return {
      DomainModelRole
    }
  },

  computed: {
    borderColor () {
      return this.item && this.item.cardType && this.item.cardType.domainModelRole === DomainModelRole.COMMAND
        ? cardTypesApi.getBackgroundColour(this.item.cardType)
        : ''
    }
  },

  methods: {
    updateDescription (html) {
      workflowApi.updateCardsMutation(this.$route.params.id, [{ cardId: this.item.id, description: html }])
    },

    focusOnCard (id) {
      if (this.item?.id === id) {
        this.$el.scrollIntoView(this.scrollIntoViewArg)
        this.$el.focus()
        if (this.$refs.editor) {
          this.$refs.editor.setCaretAtEndOfEditor()
        }
      }
    },

    moveFocus (direction, target, className) {
      this.$emit('move-focus', direction, target, className)
    }
  },

  watch: {
    focusCard: function (id) {
      this.focusOnCard(id)
    }
  },

  mounted () {
    if (!this.$store.state.isWorkflowDisabled) {
      EventBus.$on('focus-card', card => {
        this.$nextTick(() => {
          this.focusOnCard(card.id)
        })
      })
    }
  },
  beforeUnmount () {
    EventBus.$off('focus-card')
  }
}
</script>

<style>
.description p {
  margin-bottom: 0px !important;
  color: var(--text-dark);
}

.ql-editor {
  user-select: text;
}
</style>
